import { enqueueSnackbar } from "notistack";
import { apiCall } from ".";
import { getSession } from "../handlers/getSession";
import { getTenant } from "../handlers/getTenant";
import { getErrorMessage } from "./errorMessages";

//functions to handle errors and display them to the user
const showErrorMessage = (message) => {
  enqueueSnackbar(message, {
    variant: "error",
    preventDuplicate: true,
    autoHideDuration: 10000,
  });
};

// Sanitizar el codigo provisionalmente 
export const sanitizeLabel = (label) => {
  if (!label) return "";

  let sanitizedLabel = label 
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9\s]/g, "")
    .toLowerCase();

    sanitizedLabel = sanitizedLabel.replace(/\s+/g, "_");
    return sanitizedLabel;
}

// Utilidades de Revision del asesor
export const utilitiesAdvisorReview = async (
  data = { is_own: false, catalogue: "", path: "" }
) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(`${tenant}/api/advisor/review/utilities/`, {
      headers: {
        IdToken: session.IdToken,
        Authorization: `Bearer ${session.AccessToken}`,
      },
    });
    return resp.data;
  } catch (error) {
    showErrorMessage(getErrorMessage(error, "advisor_review"));
    console.error(error);
  }
};

// DETALLES DE LA REVISION DEL ASESOR
export const detailAdvisorReview = async (reportId) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.get(
      `${tenant}/api/advisor/review/detail/${reportId}/`,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    if (error?.response?.status === 404) {
      console.log("Report has not yet been reviewed by advisor");
    } else {
      console.error(error);
    }
  }
};

// CREAR REVISION DEL ASESOR
export const createAdvisiorReview = async (data = {}) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.post(
      `${tenant}/api/advisor/review/create/`,
      data,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    const errorMessage = getErrorMessage(error, "advisor_review");
    showErrorMessage(errorMessage);
    console.error(error);
    throw new Error(errorMessage, { cause: error })
  }
};

// ACTUALIZAR REVISION DEL ASESOR
export const updateAdvisiorReview = async (data = {}) => {
  const session = getSession();
  const tenant = getTenant();
  if (!session) return;
  try {
    const resp = await apiCall.put(
      `${tenant}/api/advisor/review/update/`,
      data,
      {
        headers: {
          IdToken: session.IdToken,
          Authorization: `Bearer ${session.AccessToken}`,
        },
      }
    );
    return resp.data;
  } catch (error) {
    const errorMessage = getErrorMessage(error, "advisor_review");
    showErrorMessage(errorMessage);
    throw new Error(errorMessage, { cause: error })
    console.error(error);
  }
};
